import parse from "html-react-parser"
import React from "react"
import { FormattedMessage } from "react-intl"

import { mainCatgeory } from "../../utils/post"

export function PostHeader({ post, locale }) {
  return (
    <div>
      <h1 className="block mt-16 mb-6 text-4xl font-extrabold leading-8 tracking-tight text-gray-900 sm:text-5xl">
        {post.title}
      </h1>
      <span className="flex items-center justify-between">
        {post?.categories?.nodes?.length && (
          <i className="block px-2 py-1 text-xs font-semibold tracking-wide text-white uppercase rounded bg-blue-600">
            {mainCatgeory(post).name}
          </i>
        )}
        {post[`date_${locale.slice(0, 2)}`] && (
          <span className="block my-3 italic text-gray-500">
            <FormattedMessage id="postPublish" />{" "}
            <span className="capitalize">
              {post[`date_${locale.slice(0, 2)}`]}
            </span>
          </span>
        )}
      </span>
      <div className="mt-8 text-xl leading-8 text-gray-500">
        {parse(post.excerpt)}
      </div>
    </div>
  )
}
